import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList } from "vue"
import _imports_0 from '../../assets/team-effectiveness/confirm-complete-review.png'


const _hoisted_1 = { class: "team-effectiveness-highlights-page container maxWidth-sm text-big" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"75%","max-width":"40vw"},
    alt: ""
  })
], -1)
const _hoisted_4 = { class: "col-sm-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " No more responses will be added to this review. Your report will remain available for future reference. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-chevron-left" }, null, -1)
const _hoisted_8 = { style: {"width":"100%","margin":"20px 0"} }
const _hoisted_9 = {
  key: 0,
  style: {"border":"1px solid #eeeeee","padding":"20px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-center",
  style: {"background-color":"#eeeeee","margin":"-20px","padding":"10px"}
}, " Team Effectiveness Overview ", -1)
const _hoisted_11 = {
  class: "row",
  style: {"width":"100%","margin":"0"}
}
const _hoisted_12 = { class: "" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"35px"} }, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: "text-center",
  style: {"display":"block","width":"100%","margin-top":"20px","margin-bottom":"20px"}
}
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  "data-test": "start-new-review-section"
}
const _hoisted_21 = {
  key: 3,
  class: "text-center",
  "data-test": "start-new-review-button"
}
const _hoisted_22 = { key: 4 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "You can start a new review at any time.", -1)
const _hoisted_24 = {
  key: 5,
  "data-test": "need-more-responses-message"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "You need at least 2 responses to view the latest Team Effectiveness report.", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  "data-test": "latest-report-summary"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-sm-12" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = {
  class: "col-sm-6 col-sm-offset-3",
  style: {"padding":"0 5%"}
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-sm-offset-3" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Cherish")
], -1)
const _hoisted_35 = {
  class: "col-sm-12 col-sm-offset-1",
  style: {"transform":"scale(0.7)","margin-top":"-40px","margin-bottom":"-40px"}
}
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-sm-offset-3" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Change")
], -1)
const _hoisted_38 = {
  class: "col-sm-12 col-sm-offset-1",
  style: {"transform":"scale(0.7)","margin-top":"-40px","margin-bottom":"-20px"}
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-sm-12 text-center" }
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_44 = { style: {"margin-bottom":"20px"} }
const _hoisted_45 = {
  key: 0,
  class: "row",
  "data-test": "close-review-section"
}
const _hoisted_46 = { class: "col-sm-7" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", {
  class: "glyphicon glyphicon-cog",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-7" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Change the name, deadline or delete this review if it's no longer relevant.")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_51 = { key: 4 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h3", null, "Previous reviews", -1)
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-sm-12" }
const _hoisted_57 = { class: "table table-hover history-table" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Completed"),
    /*#__PURE__*/_createElementVNode("th", null, "Number of Reviewers")
  ])
], -1)
const _hoisted_59 = { class: "history-table-diamond-cell" }
const _hoisted_60 = ["href"]
const _hoisted_61 = {
  key: 1,
  style: {"height":"300px"}
}

import { debug as d } from "debug";
import axios from "axios";
import { Modal } from "uiv";
import moment from "dayjs";
import { computed, onMounted, ref } from "vue";
import { csContext } from "../../services/cs-context";
import { TeamEffectivenessReviewApiModel, UserTeamPermissionsApiModel } from "../../api-models";
import { settleAll } from "../../services/utilities/settle-all";
import TeamEffectivenessReviewCreateDialog from "../../components/team-effectiveness/team-effectiveness-review-create-dialog.vue";
import CherishPieChartReportVisual from "../../components/team-effectiveness/cherish-pie-chart-report-visual.vue";
import ChangePieChartReportVisual from "../../components/team-effectiveness/change-pie-chart-report-visual.vue";
import HeadFromModel from "../../components/head/head-from-model.vue";
import { getTeamEffectivenessReportFlexible } from "../../components/team-effectiveness/get-team-effectiveness-report-team-id";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-highlights-page',
  props: {
    id: {}
  },
  setup(__props: any) {

const debug = d("cs.TeamEffectivenessHighlightsPage");

const reviewExists = ref(true);
const visible = ref(false);
const isConfirmingComplete = ref(false);
const latestReview = ref<TeamEffectivenessReviewApiModel | null>(null);
const latestReviewWithReport = ref<TeamEffectivenessReviewApiModel | null>(null);
const reviews = ref<TeamEffectivenessReviewApiModel[]>([]);
const userPermissions = ref<UserTeamPermissionsApiModel | null>(null);

const props = __props;

const teamId = computed(() => props.id ?? csContext.currentTeam?.id ?? "");

function getQuestionnaireUrl(): string {
  return `/team/effectivenessquestionnaire/${latestReview.value?.id}`;
}

function getReportUrl(review: TeamEffectivenessReviewApiModel | null): string {
  if (!review) return "";
  return `/teameffectivenessreport/view/${review.id}`;
}

const hasLatestReport = computed(
  () => !!latestReviewWithReport.value && latestReviewWithReport.value.questionnaires.length > 1,
);
const hasReviewInProgress = computed(
  () => !!latestReview.value && !latestReview.value.completedDate,
);
const isLatestReviewComplete = computed(
  () => !!latestReview.value && latestReview.value.completedDate,
);
const canStartNewReview = computed(
  () => !!(latestReview.value == null || isLatestReviewComplete.value),
);
const canEditCurrentReview = computed(() => hasReviewInProgress.value);
const isUserRelatedToTeam = computed(
  () =>
    !!userPermissions.value && (userPermissions.value.isMember || userPermissions.value.isLeader),
);
const hasUserCompletedQuestionnaireForReviewInProgress = computed(
  () =>
    !!latestReview.value &&
    latestReview.value.questionnaires.some(
      (q) => q.reviewerId === csContext.user.id && q.completedDate,
    ),
);
const completedReviewsSorted = computed(() =>
  reviews.value.filter(
    (r) => r.completedDate && r.questionnaires.filter((q) => q.completedDate).length,
  ),
);
const hasHistory = computed(
  () =>
    completedReviewsSorted.value.length > 1 ||
    (completedReviewsSorted.value.length === 1 && hasReviewInProgress.value),
);
const timeSinceLastCompletedReview = computed(() =>
  latestReviewWithReport.value && latestReviewWithReport.value.completedDate
    ? moment(latestReviewWithReport.value.completedDate).utc(true).fromNow()
    : "",
);

function getSortedReviewsByCompletionDateDescending(
  reviewData: TeamEffectivenessReviewApiModel[],
): TeamEffectivenessReviewApiModel[] {
  return reviewData.slice().sort((a, b) => {
    // Descending by completed date
    if (!a.completedDate) {
      return -1;
    }
    if (!b.completedDate) {
      return 1;
    }
    if (a.completedDate < b.completedDate) {
      return 1;
    }
    if (a.completedDate > b.completedDate) {
      return -1;
    }

    return 0;
  });
}

async function loadModel(): Promise<void> {
  debug("loadModel");
  const promises: Promise<void>[] = [];
  await axios
    .get(`/api/teameffectivenessreview/getallforteam?teamId=${teamId.value}`)
    .then((resp) => {
      const data = resp.data as TeamEffectivenessReviewApiModel[];
      latestReviewWithReport.value = null;
      if (data && data.length !== 0) {
        const sortedReviews = getSortedReviewsByCompletionDateDescending(data);
        reviewExists.value = true;
        [latestReview.value] = sortedReviews;
        reviews.value = sortedReviews;
      } else {
        reviewExists.value = false;
        latestReview.value = null;
        reviews.value = [];
      }
    });

  if (reviews.value) {
    // Check that the user is allowed to see the report (should they complete the questionnaire first, etc.?)
    const latestReviewWithPotentialReport =
      reviews.value.find((r) => r.questionnaires.length > 0) || null;
    if (latestReviewWithPotentialReport) {
      const latestReport = await getTeamEffectivenessReportFlexible(
        latestReviewWithPotentialReport.id,
      );
      latestReviewWithReport.value =
        !!latestReport && latestReport.status === "ReportAvailable"
          ? latestReviewWithPotentialReport
          : null;
    }
  }

  promises.push();

  promises.push(
    axios.get(`/api/teamuserpermissions/${teamId.value}`).then((resp) => {
      const data = resp.data as UserTeamPermissionsApiModel;
      userPermissions.value = data;
    }),
  );

  await settleAll(promises);
  visible.value = true;
}

const createOrUpdateDialog = ref<InstanceType<typeof TeamEffectivenessReviewCreateDialog> | null>(
  null,
);

function startOrEditReview(): void {
  if (!(canStartNewReview.value || canEditCurrentReview.value)) {
    return;
  }

  createOrUpdateDialog.value
    ?.open(teamId.value, hasReviewInProgress.value ? latestReview.value : null)
    .then((res) => {
      if (res) {
        loadModel().then(() => {
          setTimeout(() => {
            window.scrollTo({ top: 0 });
          }, 100);
        });
      }
    });
}

function back(): void {
  window.location.href = `/home?view=TeamDashboard&team=${teamId.value}`;
}

function completeReviewInProgress(): void {
  isConfirmingComplete.value = true;
}

function confirmCompleteReviewInProgress(msg: "cancel" | "dismiss" | "ok"): void {
  if (msg !== "ok" || !hasReviewInProgress.value) {
    return;
  }
  visible.value = false;
  axios
    .patch(`/api/teameffectivenessreview/complete?reviewId=${latestReview.value?.id}`)
    .finally(() => {
      loadModel().then(() => {
        window.scrollTo({ top: 0 });
      });
    });
}

function displayDeadline(dateString: string): string | null {
  const date = moment(dateString);
  return dateString
    ? date.calendar(
        null as any,
        {
          sameDay: "[today]",
          nextDay: "[by tomorrow]",
          nextWeek: "by dddd",
          lastDay: "[yesterday]",
          lastWeek: "[by last] dddd",
          sameElse: "[by] DD/MM/YYYY",
        } as any,
      )
    : null;
}

function formatCompletedDate(dateString: string): string {
  return moment(dateString).format("DD/MM/YYYY");
}

onMounted(async () => {
  await loadModel();
});

return (_ctx: any,_cache: any) => {
  const _directive_text_from_prismic = _resolveDirective("text-from-prismic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TeamEffectivenessReviewCreateDialog, {
      ref_key: "createOrUpdateDialog",
      ref: createOrUpdateDialog
    }, null, 512),
    (latestReview.value)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 0,
          ref: "confirmCompleteDialog",
          modelValue: isConfirmingComplete.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isConfirmingComplete).value = $event)),
          onHide: confirmCompleteReviewInProgress,
          title: "Confirm",
          "ok-text": "Yes",
          "cancel-text": "No"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, [
                  _createElementVNode("b", null, "Are you sure you want to close the review '" + _toDisplayString(latestReview.value.name) + "'?", 1)
                ]),
                _hoisted_5
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _hoisted_6,
    (isUserRelatedToTeam.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn-primary button-with-icon-and-text hidden-print back-button",
          onClick: back,
          type: "button"
        }, [
          _hoisted_7,
          _createTextVNode(" Back to Team ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                (hasReviewInProgress.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Your team is currently completing a Team Effectiveness Review, '" + _toDisplayString(latestReview.value?.name) + "', aiming to be ", 1),
                        _createElementVNode("b", null, "completed " + _toDisplayString(displayDeadline(latestReview.value?.deadline ?? "")), 1),
                        _createTextVNode(". "),
                        (hasUserCompletedQuestionnaireForReviewInProgress.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "You've already completed your questionnaire."))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, "You haven't yet completed your questionnaire.")),
                        _createElementVNode("span", _hoisted_17, [
                          (
                        hasReviewInProgress.value && !hasUserCompletedQuestionnaireForReviewInProgress.value
                      )
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: getQuestionnaireUrl(),
                                class: "btn btn-primary btn-lg",
                                "data-test": "complete-effectiveness-questionnaire"
                              }, "Complete the questionnaire", 8, _hoisted_18))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (hasReviewInProgress.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, null, 512)), [
                      [_directive_text_from_prismic, 'ter-highlights-page-top-guidance-review-in-progress']
                    ])
                  : _createCommentVNode("", true),
                (!hasReviewInProgress.value && !hasLatestReport.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, null, 512)), [
                      [_directive_text_from_prismic, 'ter-highlights-page-top-guidance-no-reviews']
                    ])
                  : _createCommentVNode("", true),
                (!hasReviewInProgress.value && !hasLatestReport.value && canStartNewReview.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary btn-lg",
                        onClick: startOrEditReview
                      }, " Start a new review ")
                    ]))
                  : _createCommentVNode("", true),
                (
                  !hasReviewInProgress.value && hasLatestReport.value && !!latestReviewWithReport.value?.completedDate
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("p", null, " Your team's latest Team Effectiveness Report (" + _toDisplayString(latestReviewWithReport.value?.name) + ") is available to view. It was completed " + _toDisplayString(timeSinceLastCompletedReview.value) + ". ", 1),
                      _hoisted_23
                    ]))
                  : (latestReview.value?.questionnaires.length === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                    : _createCommentVNode("", true)
              ])
            ]),
            (hasLatestReport.value)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_27))
              : _createCommentVNode("", true),
            (hasLatestReport.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("h3", null, "Summary - " + _toDisplayString(latestReviewWithReport.value?.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(HeadFromModel, {
                        kind: "TeamEffectivenessAggregateDiamond",
                        headId: latestReviewWithReport.value?.id
                      }, null, 8, ["headId"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(CherishPieChartReportVisual, {
                        reviewId: latestReviewWithReport.value?.id
                      }, null, 8, ["reviewId"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(ChangePieChartReportVisual, {
                        reviewId: latestReviewWithReport.value?.id
                      }, null, 8, ["reviewId"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("a", {
                        href: getReportUrl(latestReviewWithReport.value),
                        class: "btn btn-primary btn-lg"
                      }, "View full report", 8, _hoisted_41)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (hasReviewInProgress.value && canEditCurrentReview.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_42,
                  _hoisted_43,
                  _createElementVNode("h3", _hoisted_44, "Your review in progress - " + _toDisplayString(latestReview.value?.name), 1),
                  ((latestReview.value?.questionnaires.length ?? 0) > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", { class: "col-sm-5 text-right" }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary btn-lg",
                            onClick: completeReviewInProgress
                          }, " Close Review ")
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("p", null, " You have " + _toDisplayString(latestReview.value?.questionnaires.length) + " response" + _toDisplayString((latestReview.value?.questionnaires?.length ?? 0) > 1 ? "s" : "") + " in this review. If this is everyone who should contribute to the report, you can close the review. ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col-sm-5 text-right" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-default btn-lg",
                        onClick: startOrEditReview
                      }, [
                        _hoisted_47,
                        _createTextVNode(" Edit / Delete Review ")
                      ])
                    ]),
                    _hoisted_48
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (latestReview.value && canStartNewReview.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _hoisted_49,
                  _hoisted_50,
                  _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col-sm-12 text-center" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary btn-lg",
                        onClick: startOrEditReview
                      }, " Start a new review ")
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (hasHistory.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _hoisted_52,
                  _hoisted_53,
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("table", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(completedReviewsSorted.value, (review) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: review.id
                            }, [
                              _createElementVNode("td", _hoisted_59, [
                                _createVNode(HeadFromModel, {
                                  kind: "TeamEffectivenessAggregateDiamond",
                                  headId: review.id,
                                  showTooltips: false,
                                  fillOverride: "solid"
                                }, null, 8, ["headId"])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: getReportUrl(review),
                                  target: "_blank"
                                }, _toDisplayString(review.name), 9, _hoisted_60)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(formatCompletedDate(review.completedDate ?? "")), 1),
                              _createElementVNode("td", null, _toDisplayString(review.questionnaires.filter((q) => q.completedDate).length), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_61))
    ])
  ]))
}
}

})